"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _components = _interopRequireDefault(require("../../../styles/components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TrackGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(TrackGroup, _React$PureComponent);

  function TrackGroup() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = TrackGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        children = _this$props.children;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].TrackGroup, null, label ? /*#__PURE__*/_react["default"].createElement(_components["default"].Track, null, /*#__PURE__*/_react["default"].createElement(_components["default"].TrackGroupLabel, null, label), /*#__PURE__*/_react["default"].createElement("th", null)) : null, children);
  };

  return TrackGroup;
}(_react["default"].PureComponent);

_defineProperty(TrackGroup, "defaultProps", {
  label: ''
});

TrackGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes["default"].string
} : {};
var _default = TrackGroup;
exports["default"] = _default;